import { render, staticRenderFns } from "./auth_role_edit.vue?vue&type=template&id=852ec5d0&scoped=true&"
import script from "./auth_role_edit.vue?vue&type=script&lang=js&"
export * from "./auth_role_edit.vue?vue&type=script&lang=js&"
import style0 from "./auth_role_edit.vue?vue&type=style&index=0&id=852ec5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ec5d0",
  null
  
)

export default component.exports